import React from 'react'
import { Badge, Icon, Tile, TileCaption } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { BREAKPOINTS } from '@mc/media'
import Image from 'components/LegacyImage'
import { CourseMeta, OutcomeContent } from 'types/data'
import { useVideoContext, VideoContextProps } from '../VideoContext'
import styles from './OutcomeTile.module.scss'

export const CourseContentTile = ({
  content,
  courseMeta,
  isPrioritized,
  trackOnClick,
}: {
  content: OutcomeContent
  courseMeta: CourseMeta
  isPrioritized: boolean
  trackOnClick: () => void
}) => {
  const { openVideo } = useVideoContext<VideoContextProps>()
  const { t } = useTranslation('@mc/next')

  return (
    <Tile
      aspectRatio='auto'
      className={styles.tileContent}
      onClick={() => {
        if (courseMeta.trailerMediaUuid) {
          trackOnClick()
          openVideo(courseMeta)
        }
      }}
    >
      <TileCaption position='right top' padding={2}>
        <Badge kind='dim'>
          <span className='mc-text--capitalize'>
            {t('subcategoryPage.tile.classInfoPill.type')}
            {!!content.numberOfLessons &&
              t('subcategoryPage.tile.classInfoPill.detail', {
                numberOfLessons: content.numberOfLessons,
              })}
          </span>
        </Badge>
      </TileCaption>
      {courseMeta.trailerMediaUuid && (
        <TileCaption position='center center' padding={4}>
          <Icon kind='play-circle' className='mc-icon--6' />
        </TileCaption>
      )}
      <Image
        objectFit='cover'
        src={content.tileImgSrc}
        alt=''
        className='mc-corners--3'
        layout='fill'
        sizes={`(max-width: ${BREAKPOINTS.SM}px) 90vw, 25vw`}
        priority={isPrioritized}
      />
    </Tile>
  )
}
